import { ModalForm } from "@ant-design/pro-components";

const LeadFullInfo = ({ onClose, data }) => {
  return <ModalForm visible={true} onFinish={onClose}></ModalForm>;
};

export default LeadFullInfo;
